"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const i18n_js_1 = __importDefault(require("i18n-js"));
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const HourlyForecastLinear_1 = __importDefault(require("../../../../common/components/Weather/HourlyForecastLinear"));
const DayForecastLinear_1 = __importDefault(require("../../../../common/components/Weather/DayForecastLinear"));
const helpers_1 = require("../../../../common/helpers/helpers");
const weatherHelpers_1 = require("../../../../common/helpers/weatherHelpers");
const WeatherSlideContainer = styled_components_1.default.div `
  height: 100%;
  width: 100%;
  padding-inline: 25vmin;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  @media (orientation: portrait) {
    padding: 5vmin;
    justify-content: center;
    gap: 6vh;

    @media (max-height: 1240px) {
      justify-content: flex-start;
    }
  }

  &.sunny {
    background: linear-gradient(330deg, #00416a, #d4f2ff);
  }

  &.rain {
    background: linear-gradient(to bottom right, rgba(174, 189, 194, 1), rgba(81, 90, 95, 1));
  }

  &.snow {
    background: linear-gradient(to bottom right, rgba(173, 192, 214, 1), rgba(173, 192, 214, 1));
  }

  &.night {
    background: linear-gradient(to bottom right, rgba(49, 83, 121, 1), rgba(0, 0, 0, 1));
  }

  .day-weathers {
    &.hidden {
      display: none;
    }

    animation-duration: ${(props) => props.slideInTime * 1}s;

    display: flex;
    justify-content: space-between;

    @media (orientation: portrait) {
      flex-direction: column;
      gap: 3vh;
    }
  }

  .lower-contents {
    @media (orientation: portrait) {
      margin-inline: 15vmin;
    }

    .day-1,
    .day-2,
    .day-3,
    .day-4 {
      height: 30vmin;

      @media (orientation: portrait) {
        height: 15vmin;

        @media (max-height: 1240px) {
          height: 13vmin;
        }
      }
    }
  }

  .now,
  .weather-location {
    color: #fff;
  }

  .now,
  .summary {
    font-size: 3vmin;
    font-weight: 400;

    @media (orientation: portrait) {
      font-size: 3vmin;
    }
  }

  .summary {
    font-size: 3.5vmin;
  }

  .temperature {
    font-size: 12vmin;
    font-weight: 500;
    letter-spacing: -0.97px;
    margin-right: 1.5vmin;
    margin-top: 3vmin;
    line-height: 11vmin;

    @media (orientation: portrait) {
      font-size: 9vmin;
      line-height: 9vmin;
    }
  }

  .weather-location {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
  }

  .time-now {
    color: #fff;
    font-weight: 400;
    font-size: 3.35vw;
    margin-top: 2.5vw;
    text-align: right;

    @media (orientation: portrait) {
      display: none;
    }

    &.time-landscape-mode {
      animation-duration: ${(props) => props.slideInTime * 1}s;
    }
  }

  .time-portrait-mode {
    display: none;

    @media (orientation: portrait) {
      display: block;
    }
  }

  .day-week-name {
    font-size: 3vmin;
  }
`;
const ContentBox = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 25px;
`;
const WeatherSlide = ({ weatherData, venue }) => {
    const { symbol } = weatherData.current;
    const currentWeatherIsBad = !!(symbol === 'rain' || symbol === 'snow' || symbol === 'sleet');
    const timeNow = helpers_1.Helpers.convertDateToTimezone(new Date().toISOString(), venue.timezone, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: i18n_js_1.default.currentLocale() === 'en',
    });
    const weatherClass = (0, weatherHelpers_1.getWeatherClass)(weatherData, venue);
    const weatherSummary = i18n_js_1.default.t(`weather.${symbol}`);
    return (react_1.default.createElement(WeatherSlideContainer, { className: `${weatherClass}` },
        react_1.default.createElement(ContentBox, null,
            react_1.default.createElement(material_1.Box, { className: `day-weathers` },
                react_1.default.createElement(material_1.Box, null,
                    react_1.default.createElement(material_1.Typography, { className: "now" },
                        " ",
                        i18n_js_1.default.t('dictionary.weather.now').toUpperCase(),
                        " "),
                    react_1.default.createElement(material_1.Box, { className: "weather-location" },
                        react_1.default.createElement(material_1.Box, { display: "flex", alignItems: "flex-end" },
                            react_1.default.createElement(material_1.Typography, { className: "temperature" },
                                " ",
                                weatherData.current.temperature,
                                "\u00B0 "),
                            react_1.default.createElement(material_1.Typography, { className: "summary" },
                                " ",
                                weatherSummary,
                                " ")),
                        react_1.default.createElement(material_1.Box, { className: "time-now time-portrait-mode" },
                            " ",
                            timeNow,
                            " "))),
                (weatherData === null || weatherData === void 0 ? void 0 : weatherData.hourlyForecast) && react_1.default.createElement(HourlyForecastLinear_1.default, { forecast: weatherData.hourlyForecast, asSlide: false })),
            react_1.default.createElement(material_1.Box, { className: `lower-contents` },
                react_1.default.createElement(DayForecastLinear_1.default, { forecast: weatherData.forecast, currentWeatherIsBad: currentWeatherIsBad }),
                react_1.default.createElement(material_1.Box, { className: `time-now time-landscape-mode` },
                    " ",
                    timeNow,
                    " ")))));
};
const mapStoreToProps = store => ({
    weatherData: store.getValue('weather'),
    venue: store.getValue('venue'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(WeatherSlide);
